export const ESection: any = [
  { label: "unknown", value: "unknown" },
  { label: "woman", value: "woman" },
  { label: "man", value: "man" },
  { label: "kids", value: "kids" },
];
